import React from 'react';
import { Check } from 'lucide-react';

const CheckItem = ({ 
  children, 
  title = '',
  bgColor = 'bg-blue-100',
  textColor = 'text-blue-600',
  iconSize = 'h-5 w-5'
}) => {
  return (
    <div className="flex items-start">
      <div className={`${bgColor} p-2 rounded-full mr-4 flex-shrink-0`}>
        <Check className={`${iconSize} ${textColor}`} />
      </div>
      <div>
        {title && <h3 className="text-xl font-semibold mb-2">{title}</h3>}
        {children}
      </div>
    </div>
  );
};

export default CheckItem;